"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[847],{

/***/ 90606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Page; },
  "getPageData": function() { return /* binding */ getPageData; },
  "getStaticPageProps": function() { return /* binding */ getStaticPageProps; },
  "usePageData": function() { return /* binding */ usePageData; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(55380);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../packages/prismic/src/prismicContext.tsx
var prismicContext = __webpack_require__(72066);
// EXTERNAL MODULE: ../../packages/prismic/src/Prismic.tsx + 9 modules
var Prismic = __webpack_require__(11420);
// EXTERNAL MODULE: ../../packages/prismic/src/fallback.tsx
var fallback = __webpack_require__(16967);
// EXTERNAL MODULE: ../../packages/ui/src/components/buttons/Button.tsx + 1 modules
var Button = __webpack_require__(11709);
// EXTERNAL MODULE: ../../packages/ui/src/styles/theme.ts
var theme = __webpack_require__(58176);
// EXTERNAL MODULE: ../../packages/ui/src/components/sliderList/SliderListItem.tsx
var SliderListItem = __webpack_require__(25603);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/shared/src/components/subnav/MobileSubnav.tsx
var MobileSubnav = __webpack_require__(81425);
// EXTERNAL MODULE: ../../packages/shared/src/components/subnav/Subnav.tsx + 1 modules
var Subnav = __webpack_require__(20204);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../packages/shared/src/containers/SubnavContainer.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var StyledA = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e6g0nzi1"
} : 0)( true ? {
  name: "4xr3j4",
  styles: "@media (min-width: 1400px){white-space:nowrap;}"
} : 0);

var CtaButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* Button */.z,  true ? {
  target: "e6g0nzi0"
} : 0)("min-width:", function (props) {
  return props.mobile ? 'auto' : '145px;';
}, ";min-height:45px;padding:0 36px;" + ( true ? "" : 0));

function SubnavContainer(_ref) {
  var _linkdata$title, _linkdata$title2, _items$find;

  var page = _ref.page,
      active = _ref.active,
      ctaLink = _ref.ctaLink,
      ctaText = _ref.ctaText,
      ctaMobileText = _ref.ctaMobileText,
      isTransparent = _ref.isTransparent,
      titleWidth = _ref.titleWidth,
      className = _ref.className;
  var router = (0,next_router.useRouter)();

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var items = (page.sub_navigation || []).map(function (item) {
    var _item$link, _item$link$_meta, _active$_meta;

    var link = Prismic/* Prismic.link */.X5.link(urlResolver, item === null || item === void 0 ? void 0 : item.link, item === null || item === void 0 ? void 0 : item.link_text);
    if (!link) return null;
    var id = item === null || item === void 0 ? void 0 : (_item$link = item.link) === null || _item$link === void 0 ? void 0 : (_item$link$_meta = _item$link._meta) === null || _item$link$_meta === void 0 ? void 0 : _item$link$_meta.id;
    var isActive = id === (active === null || active === void 0 ? void 0 : (_active$_meta = active._meta) === null || _active$_meta === void 0 ? void 0 : _active$_meta.id) || link.as === router.asPath;
    return _objectSpread({
      item: item,
      id: id,
      active: isActive
    }, link);
  });
  var linkdata = (0,fallback/* getDataFromLink */.rm)(ctaLink);
  var buttonTitle = (0,fallback/* fallbackText */.mn)(ctaText, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  var action = ctaLink ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: ctaLink,
    title: buttonTitle !== null && buttonTitle !== void 0 ? buttonTitle : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaButton, {
      as: 'a',
      title: buttonTitle,
      bg: theme/* theme.colors.primary */.r.colors.primary
    })
  }) : null;
  var mobileButtonTitle = (0,fallback/* fallbackText */.mn)(ctaMobileText, (_linkdata$title2 = linkdata.title) !== null && _linkdata$title2 !== void 0 ? _linkdata$title2 : undefined);
  var mobileAction = ctaLink && ctaMobileText ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: ctaLink,
    title: mobileButtonTitle !== null && mobileButtonTitle !== void 0 ? mobileButtonTitle : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaButton, {
      as: 'a',
      title: mobileButtonTitle,
      mobile: true,
      bg: theme/* theme.colors.secondary */.r.colors.secondary
    })
  }) : null;
  var activeTitle = active === undefined ? Prismic/* Prismic.text */.X5.text(page === null || page === void 0 ? void 0 : page.page_title) : active.page_title ? Prismic/* Prismic.text */.X5.text(active === null || active === void 0 ? void 0 : active.page_title) : (_items$find = items.find(function (item) {
    return item === null || item === void 0 ? void 0 : item.active;
  })) === null || _items$find === void 0 ? void 0 : _items$find.title;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Subnav */.G, {
    titleWidth: titleWidth,
    title: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: urlResolver(page === null || page === void 0 ? void 0 : page._meta).as,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: Prismic/* Prismic.text */.X5.text(page.page_title)
      })
    }),
    pageTitle: activeTitle !== null && activeTitle !== void 0 ? activeTitle : undefined,
    cta: action,
    mobilecta: mobileAction,
    isTransparent: isTransparent,
    className: className,
    mobileItems: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSubnav/* SubItem */.u, {
        active: items.find(function (item) {
          return item === null || item === void 0 ? void 0 : item.active;
        }) === undefined,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
          href: urlResolver(page === null || page === void 0 ? void 0 : page._meta).as,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            children: Prismic/* Prismic.text */.X5.text(page.page_title)
          })
        })
      }, "parent"), items.filter(function (x) {
        return !!(x !== null && x !== void 0 && x.item.link);
      }).map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSubnav/* SubItem */.u, {
          active: item === null || item === void 0 ? void 0 : item.active,
          "aria-current": item !== null && item !== void 0 && item.active ? 'page' : 'false',
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: item === null || item === void 0 ? void 0 : item.as,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
              children: item === null || item === void 0 ? void 0 : item.title
            })
          })
        }, index);
      })]
    }),
    children: items.filter(function (x) {
      return !!(x !== null && x !== void 0 && x.item.link);
    }).map(function (item, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliderListItem/* SliderListItem */.P, {
        active: item === null || item === void 0 ? void 0 : item.active,
        "aria-current": item !== null && item !== void 0 && item.active ? 'page' : 'false',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
          href: item === null || item === void 0 ? void 0 : item.as,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledA, {
            children: item === null || item === void 0 ? void 0 : item.title
          })
        })
      }, index);
    })
  });
}
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/lodash.truncate/index.js
var lodash_truncate = __webpack_require__(7391);
var lodash_truncate_default = /*#__PURE__*/__webpack_require__.n(lodash_truncate);
;// CONCATENATED MODULE: ../../packages/shared/src/components/templates/meta/Meta.tsx


function Meta_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Meta_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Meta_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Meta_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Meta = function Meta(_ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      imageAlt = _ref.imageAlt,
      author = _ref.author,
      seoTitle = _ref.seoTitle,
      siteName = _ref.siteName;
  var meta = [{
    property: 'og:title',
    content: seoTitle !== null && seoTitle !== void 0 ? seoTitle : title
  }, {
    property: 'og:site_name',
    content: siteName !== null && siteName !== void 0 ? siteName : 'Landsbankinn.is'
  }, {
    property: 'og:type',
    content: 'website'
  },
  /* { property: 'fb:app_id', content: '' }, */
  {
    property: 'fb:admins',
    content: '100003112871506'
  }, {
    name: 'twitter:title',
    content: title
  }, {
    name: 'twitter:card',
    content: 'summary'
  }, {
    name: 'twitter:site',
    content: '@landsbankinn'
  }];
  var shareImage = image ? image : null;

  if (description) {
    var truncatedDescription = lodash_truncate_default()(description.replace(/\n+/g, ' '), {
      length: 300,
      separator: '. '
    });
    meta.push({
      name: 'description',
      content: truncatedDescription
    }, {
      property: 'og:description',
      content: truncatedDescription
    }, {
      name: 'twitter:description',
      content: truncatedDescription
    });
  }

  if (shareImage) {
    meta.push({
      property: 'og:image',
      content: shareImage
    }, {
      property: 'og:image:width',
      content: '1200px'
    }, {
      property: 'og:image:height',
      content: '630px'
    }, {
      property: 'og:image:alt',
      content: imageAlt
    }, {
      name: 'twitter:image',
      content: shareImage
    });
  }

  if (author) {
    meta.push({
      name: 'author',
      content: author
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
      children: title
    }), meta.map(function (item, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", Meta_objectSpread({}, item), "meta-".concat(index));
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "image_src",
      href: shareImage !== null && shareImage !== void 0 ? shareImage : undefined
    })]
  });
};

/* harmony default export */ var meta_Meta = (Meta);
;// CONCATENATED MODULE: ../../packages/shared/src/prismicContainers/MetaContainer.tsx








function SchemaOrgBreadcrumbs(_ref) {
  var items = _ref.items,
      canonicalUrlBase = _ref.canonicalUrlBase;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: index + 1,
            name: item.title,
            item: "".concat(canonicalUrlBase).concat(item.url)
          };
        })
      })
    }
  });
}

var MetaContainer = function MetaContainer(_ref2) {
  var _title, _seoTitle, _seoImage$seo;

  var data = _ref2.data,
      breadcrumbs = _ref2.breadcrumbs,
      defaultTitle = _ref2.defaultTitle,
      defaultImage = _ref2.defaultImage,
      defaultDescription = _ref2.defaultDescription,
      _ref2$author = _ref2.author,
      author = _ref2$author === void 0 ? undefined : _ref2$author,
      _ref2$isFrontPage = _ref2.isFrontPage,
      isFrontPage = _ref2$isFrontPage === void 0 ? false : _ref2$isFrontPage,
      canonicalUrlBase = _ref2.canonicalUrlBase,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'page' : _ref2$type,
      siteName = _ref2.siteName;
  var seoTitle = (0,fallback/* fallbackText */.mn)(data.seo_title, data.page_title, data.title);
  var title = (0,fallback/* fallbackText */.mn)(data.seo_title, data.page_title, data.title);
  var seoDescription = (0,fallback/* fallbackText */.mn)(data === null || data === void 0 ? void 0 : data.seo_description, data === null || data === void 0 ? void 0 : data.abstract, defaultDescription);
  var seoImage = (0,fallback/* fallbackImage */.bU)(data === null || data === void 0 ? void 0 : data.seo_image, data === null || data === void 0 ? void 0 : data.abstract_image, defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.seo);

  if (breadcrumbs && breadcrumbs.length && !data.seo_title) {
    // Render breadrumbs as title
    seoTitle = breadcrumbs.slice().reverse().map(function (p) {
      return p.title;
    }).join(' - ');
  }

  title = isFrontPage ? seoTitle : "".concat(seoTitle, " - ").concat(Prismic/* Prismic.text */.X5.text(defaultTitle)); // Canonical url is doing more harm than good as is, needs a refactor/rethink

  /*   const canonicalUrl = `${CANONICAL_URL_BASE}${linkResolver({
    ...data?._meta,
    type,
  })}`; */

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
      children: breadcrumbs && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SchemaOrgBreadcrumbs, {
        items: breadcrumbs,
        canonicalUrlBase: canonicalUrlBase
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(meta_Meta, {
      title: (_title = title) !== null && _title !== void 0 ? _title : '',
      seoTitle: (_seoTitle = seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : undefined,
      description: seoDescription,
      image: seoImage !== null && seoImage !== void 0 && seoImage.seo ? seoImage === null || seoImage === void 0 ? void 0 : (_seoImage$seo = seoImage.seo) === null || _seoImage$seo === void 0 ? void 0 : _seoImage$seo.url : seoImage === null || seoImage === void 0 ? void 0 : seoImage.url,
      imageAlt: seoImage === null || seoImage === void 0 ? void 0 : seoImage.alt,
      author: author,
      siteName: siteName !== null && siteName !== void 0 ? siteName : undefined
    })]
  });
};
// EXTERNAL MODULE: ../../packages/shared/src/prismicContainers/SlicesContainer.tsx + 300 modules
var SlicesContainer = __webpack_require__(1533);
// EXTERNAL MODULE: ../../packages/ui/src/styles/mixins.ts
var mixins = __webpack_require__(2522);
// EXTERNAL MODULE: ../../packages/utils/src/index.ts + 22 modules
var src = __webpack_require__(46039);
// EXTERNAL MODULE: ./src/lib/config.ts
var config = __webpack_require__(64088);
// EXTERNAL MODULE: ./src/lib/linkResolver.ts
var linkResolver = __webpack_require__(53513);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(31230);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js
var graphql_tag_lib = __webpack_require__(10081);
;// CONCATENATED MODULE: ../../packages/shared/src/graphql/prismic/fragments/linkFragment.ts


var _templateObject;


var LinkFragment = (0,graphql_tag_lib/* gql */.Ps)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment LinkFragment on _Linkable {\n    __typename\n    _linkType\n    ... on _Document {\n      _meta {\n        id\n        uid\n        type\n        lang\n      }\n    }\n    ... on _ImageLink {\n      name\n      url\n      size\n      height\n      width\n    }\n    ... on _FileLink {\n      name\n      url\n      size\n    }\n    ... on _ExternalLink {\n      url\n    }\n    ... on Page {\n      page_title\n      abstract\n      abstract_image\n      _meta {\n        id\n        uid\n        tags\n        lang\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ./src/graphql/prismic/fragments/arsskyrslaFragments.ts


var arsskyrslaFragments_templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;


var SliceQuarters = (0,lib/* gql */.Ps)(arsskyrslaFragments_templateObject || (arsskyrslaFragments_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceQuarters on PageBodyQuarters {\n    type\n    fields {\n      copy\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SliceTable = (0,lib/* gql */.Ps)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceTable on PageBodyTable {\n    type\n    primary {\n      bg: background\n      layout\n      zebra_color\n      text\n      table_title\n      table\n    }\n  }\n"])));
var SliceTextWithImages = (0,lib/* gql */.Ps)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceTextWithImages on PageBodyText_with_images {\n    type\n    primary {\n      title\n      copy\n      align\n      link_text\n      aspect_ratio\n      link {\n        ...LinkFragment\n      }\n      link_2_text\n      link_2 {\n        ...LinkFragment\n      }\n    }\n    fields {\n      image\n      video\n      embed\n      infogramid\n    }\n  }\n"])));
var SliceAccordion = (0,lib/* gql */.Ps)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceAccordion on PageBodyAccordion {\n    type\n    primary {\n      is_open\n      single_display\n    }\n    fields {\n      page {\n        ... on Page {\n          _meta {\n            id\n            uid\n            tags\n            lang\n          }\n          page_title\n          body {\n            ...SliceQuarters\n            ...SliceTextWithImages\n            ...SliceTable\n            ...SliceText\n          }\n        }\n      }\n    }\n  }\n"])));
var SlicePoints = (0,lib/* gql */.Ps)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SlicePointsArsskyrsla on PageBodyPoints {\n    type\n    fields {\n      title\n      text\n    }\n    primary {\n      title\n      text\n      featured_point_title\n      featured_point_text\n    }\n  }\n"])));
var SliceFaq = (0,lib/* gql */.Ps)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceFaq on PageBodyFaq {\n    type\n    primary {\n      heading\n      single_display\n    }\n    fields {\n      item {\n        ... on Faq_item {\n          question\n          answer\n        }\n      }\n      category {\n        ... on Faq_category {\n          title\n        }\n      }\n    }\n  }\n"])));
var SliceInterestCallout = (0,lib/* gql */.Ps)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceInterestCallout on PageBodyInterest_callout {\n    type\n    label\n    fields {\n      title\n      copy\n      sub_title\n      number\n      number_color\n      subtitle_position\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SliceStaffWithContact = (0,lib/* gql */.Ps)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceStaffWithContact on PageBodyStaff_with_contact {\n    type\n    primary {\n      title\n    }\n    fields {\n      employee {\n        ... on Employee {\n          image\n          name\n          title\n          email\n          phone\n          location\n        }\n      }\n      show_image\n    }\n  }\n"])));
var SliceStaffWithBio = (0,lib/* gql */.Ps)(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceStaffWithBio on PageBodyStaff_with_bio {\n    type\n    primary {\n      title\n    }\n    fields {\n      employee {\n        ... on Employee {\n          image\n          name\n          title\n          bio\n        }\n      }\n    }\n  }\n"])));
var SliceNewsCards = (0,lib/* gql */.Ps)(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceNewsCards on PageBodyNews_cards {\n    type\n    primary {\n      heading\n      heading_link {\n        ...LinkFragment\n      }\n      featured\n      articles\n    }\n    fields {\n      article {\n        ...LinkFragment\n      }\n      category {\n        ... on Article_category {\n          _meta {\n            id\n            uid\n          }\n          title\n        }\n      }\n    }\n  }\n"])));
var SliceMoreInfo = (0,lib/* gql */.Ps)(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceMoreInfo on PageBodyMore_info {\n    type\n    primary {\n      title\n      expandable\n    }\n    fields {\n      image\n      title\n      copy\n      expandable\n    }\n  }\n"])));
var SliceShortcuts = (0,lib/* gql */.Ps)(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceShortcuts on PageBodyShortcuts {\n    type\n    fields {\n      icon\n      link {\n        ...LinkFragment\n      }\n      link_text\n    }\n  }\n"])));
var SliceTextWithAuthors = (0,lib/* gql */.Ps)(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceTextWithAuthors on PageBodyText_with_authors {\n    type\n    primary {\n      copy\n    }\n    fields {\n      twa_author {\n        ... on Author {\n          name\n          job_title\n          image\n        }\n      }\n    }\n  }\n"])));
var SliceInfogram = (0,lib/* gql */.Ps)(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleInfogram on PageBodyInfogram {\n    type\n    primary {\n      infogramid\n      infogramid_2\n      infogramid_3\n    }\n  }\n"])));
var SliceBuzzsprout = (0,lib/* gql */.Ps)(_templateObject15 || (_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleBuzzsprout on PageBodyBuzzsprout {\n    type\n    primary {\n      url\n    }\n  }\n"])));
var QuoteExpand = (0,lib/* gql */.Ps)(_templateObject16 || (_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment QuoteExpand on PageBodyQuote_expand {\n    type\n    primary {\n      title\n      copy\n      expandable_copy\n      top_splitter\n    }\n    fields {\n      author {\n        ... on Author {\n          name\n          job_title\n          image\n        }\n      }\n    }\n  }\n"])));
var arsskyrslaFragments = [SliceQuarters, SliceAccordion, SlicePoints, SliceTable, SliceFaq, SliceInterestCallout, SliceStaffWithContact, SliceStaffWithBio, SliceNewsCards, SliceMoreInfo, SliceShortcuts, SliceTextWithAuthors, SliceTextWithImages, SliceInfogram, SliceBuzzsprout, QuoteExpand];
;// CONCATENATED MODULE: ../../packages/shared/src/graphql/prismic/fragments/sliceFragments.ts


var sliceFragments_templateObject, sliceFragments_templateObject2, sliceFragments_templateObject3, sliceFragments_templateObject4, sliceFragments_templateObject5, sliceFragments_templateObject6, sliceFragments_templateObject7, sliceFragments_templateObject8, sliceFragments_templateObject9, sliceFragments_templateObject10, sliceFragments_templateObject11, sliceFragments_templateObject12, sliceFragments_templateObject13, sliceFragments_templateObject14, sliceFragments_templateObject15, sliceFragments_templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69;


var FrontPageHero = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject || (sliceFragments_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment FrontPageHero on PageBodyFrontpage_hero {\n    type\n    primary {\n      alignment\n      title\n      text_center\n      text_bottom\n      shade_opacity\n      image\n      button_text\n      title_width\n      title_position\n      title_color\n      font_size\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SubPageHero = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject2 || (sliceFragments_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SubPageHero on PageBodyHero {\n    type\n    primary {\n      background_color\n      title\n      smaller_font\n      copy\n      image\n      image_overflow\n      hero_video: video {\n        ...LinkFragment\n      }\n      button_text\n      special_hero\n      link {\n        ...LinkFragment\n      }\n      button_text_2\n      link_2 {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var CompactHero = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject3 || (sliceFragments_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment CompactHero on PageBodyCompact_hero {\n    type\n    primary {\n      title\n      copy\n    }\n  }\n"])));
var SliceJotForm = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject4 || (sliceFragments_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceJotForm on PageBodyJotform {\n    type\n    primary {\n      url\n    }\n  }\n"])));
var SliceText = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject5 || (sliceFragments_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceText on PageBodyText {\n    type\n    primary {\n      text\n      indent\n    }\n  }\n"])));
var SliceTextWithPoints = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject6 || (sliceFragments_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceTextWithPoints on PageBodyText_with_points {\n    type\n    primary {\n      title\n      title_size\n      copy\n      copy_size\n      link {\n        ...LinkFragment\n      }\n      link_text\n      points_type\n      points_color\n      line_splitter\n      columns_count\n      points_location\n      point_copy_size\n    }\n    fields {\n      copy: item\n      icon\n      label\n      point_link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SliceIntroText = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject7 || (sliceFragments_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceIntroText on PageBodyIntro_text {\n    type\n    primary {\n      title\n      copy\n      copy_size\n      link {\n        ...LinkFragment\n      }\n      link_text\n    }\n  }\n"])));
var SliceImages = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject8 || (sliceFragments_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceImages on PageBodyImages {\n    type\n    primary {\n      title\n      copy\n      aspect_ratio\n      featured\n      issvg\n      columns\n    }\n    fields {\n      image_title\n      image_copy\n      image\n      video\n    }\n  }\n"])));
var SliceEmbed = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject9 || (sliceFragments_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceEmbed on PageBodyEmbed {\n    type\n    primary {\n      embed\n      embed2\n      height\n    }\n  }\n"])));
var SliceTableWithImages = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject10 || (sliceFragments_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceTableWithImages on PageBodyTable_with_images {\n    type\n    primary {\n      footer_text\n      has_header\n    }\n    fields {\n      image\n      text_1\n      text_2\n      text_3\n      text_4\n      text_5\n      isheader\n    }\n  }\n"])));
var SliceRelatedContent = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject11 || (sliceFragments_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceRelatedContent on PageBodyRelated_content {\n    type\n    fields {\n      title\n      copy\n      link {\n        ...LinkFragment\n        ... on Page {\n          _meta {\n            id\n            uid\n            tags\n            lang\n          }\n          body {\n            __typename\n            ... on PageBodyHero {\n              type\n              primary {\n                title\n              }\n            }\n          }\n        }\n      }\n      icon\n    }\n  }\n"])));
var SliceProductCards = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject12 || (sliceFragments_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceProductCards on PageBodyProduct_cards {\n    type\n    primary {\n      featured\n      align\n      four_in_row\n    }\n    fields {\n      image\n      heading\n      copy\n      video\n      text_in_image\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SliceArticleCards = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject13 || (sliceFragments_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceArticleCards on PageBodyArticle_cards {\n    type\n    primary {\n      align\n      title\n      link {\n        ...LinkFragment\n      }\n    }\n    fields {\n      image\n      heading\n      copy\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SliceOtherCards = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject14 || (sliceFragments_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceOtherCards on PageBodyOther_cards {\n    type\n    primary {\n      featured\n    }\n    fields {\n      image\n      title\n      copy\n      link {\n        ...LinkFragment\n      }\n      link_text\n    }\n  }\n"])));
var SliceTextCards = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject15 || (sliceFragments_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceTextCards on PageBodyText_cards {\n    type\n    fields {\n      title\n      copy\n      link {\n        ...LinkFragment\n      }\n      link_text\n    }\n  }\n"])));
var SliceDownloadLinks = (0,graphql_tag_lib/* gql */.Ps)(sliceFragments_templateObject16 || (sliceFragments_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceDownloadLinks on PageBodyDownload_links {\n    type\n    primary {\n      app_store {\n        ...LinkFragment\n      }\n      google_play {\n        ...LinkFragment\n      }\n      apple_link_text\n      google_link_text\n    }\n  }\n"])));
var HighlightNumbers = (0,graphql_tag_lib/* gql */.Ps)(_templateObject17 || (_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment HighlightNumbers on PageBodyHighlight_numbers {\n    type\n    primary {\n      size\n      color\n    }\n    fields {\n      title\n      copy\n      prefix\n      number\n      suffix\n    }\n  }\n"])));
var SlicePageVideo = (0,graphql_tag_lib/* gql */.Ps)(_templateObject18 || (_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SlicePageVideo on PageBodyVideo_el {\n    type\n    primary {\n      body_video: video {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SliceArticleHero = (0,graphql_tag_lib/* gql */.Ps)(_templateObject19 || (_templateObject19 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceArticleHero on PageBodyArticle_hero {\n    type\n    primary {\n      a_link {\n        ...LinkFragment\n      }\n      a_link_text\n      a_title\n      a_image\n      a_abstract\n    }\n  }\n"])));
var SliceFeaturedArticles = (0,graphql_tag_lib/* gql */.Ps)(_templateObject20 || (_templateObject20 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceFeaturedArticles on PageBodyFeatured_articles {\n    type\n    fields {\n      a_article {\n        ...LinkFragment\n      }\n      a_image\n      a_title\n      a_abstract\n    }\n  }\n"])));
var SliceTextWithImage = (0,graphql_tag_lib/* gql */.Ps)(_templateObject21 || (_templateObject21 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceTextWithImage on PageBodyText_with_image {\n    type\n    primary {\n      copy\n      image\n      align\n    }\n  }\n"])));
var SliceTextWithVideo = (0,graphql_tag_lib/* gql */.Ps)(_templateObject22 || (_templateObject22 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceTextWithVideo on PageBodyText_with_video {\n    type\n    primary {\n      copy\n      video\n      align\n    }\n  }\n"])));
var SliceTextWithPullOut = (0,graphql_tag_lib/* gql */.Ps)(_templateObject23 || (_templateObject23 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceTextWithPullOut on PageBodyText_with_pull_out {\n    type\n    primary {\n      copy\n      pullout\n    }\n  }\n"])));
var SliceTextWithWithSideText = (0,graphql_tag_lib/* gql */.Ps)(_templateObject24 || (_templateObject24 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceTextWithSideText on PageBodyText_with_side_text {\n    type\n    primary {\n      copy\n      side_text\n      side_title\n    }\n  }\n"])));
var SliceTextWithRelated = (0,graphql_tag_lib/* gql */.Ps)(_templateObject25 || (_templateObject25 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceTextWithRelated on PageBodyText_with_related {\n    type\n    primary {\n      copy\n    }\n    fields {\n      image\n      title\n      copy\n      link_text\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SliceTextWithLinks = (0,graphql_tag_lib/* gql */.Ps)(_templateObject26 || (_templateObject26 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceTextWithLinks on PageBodyText_with_links {\n    type\n    primary {\n      title\n      copy\n    }\n    fields {\n      link_text\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var SliceQuote = (0,graphql_tag_lib/* gql */.Ps)(_templateObject27 || (_templateObject27 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceQuote on PageBodyQuote {\n    type\n    primary {\n      quote\n      author\n      position\n      align\n    }\n  }\n"])));
var SliceVideo = (0,graphql_tag_lib/* gql */.Ps)(_templateObject28 || (_templateObject28 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceVideo on PageBodyVideo {\n    type\n    primary {\n      title1\n      copy\n      video\n    }\n  }\n"])));
var SliceEmphasisText = (0,graphql_tag_lib/* gql */.Ps)(_templateObject29 || (_templateObject29 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ArticleSliceEmphasisText on PageBodyEmphasis_text {\n    type\n    primary {\n      copy\n    }\n  }\n"])));
var AnnualHero = (0,graphql_tag_lib/* gql */.Ps)(_templateObject30 || (_templateObject30 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment AnnualHero on PageBodyAnnual_report_hero {\n    type\n    primary {\n      title\n      image\n      shade_opacity\n    }\n  }\n"])));
var SliceAnnualModule = (0,graphql_tag_lib/* gql */.Ps)(_templateObject31 || (_templateObject31 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment AnnualModule on PageBodyAnnual_module {\n    type\n    primary {\n      copy\n      action_link {\n        ...LinkFragment\n      }\n      action_title\n      charts\n      layout_type\n    }\n    fields {\n      a_title\n      value\n      percentage\n    }\n  }\n"])));
var Tiles = (0,graphql_tag_lib/* gql */.Ps)(_templateObject32 || (_templateObject32 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment Tiles on PageBodyTiles {\n    type\n    fields {\n      number\n      title\n      copy\n      icon\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var AnnualIntro = (0,graphql_tag_lib/* gql */.Ps)(_templateObject33 || (_templateObject33 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment AnnualIntro on PageBodyAnnual_intro {\n    type\n    primary {\n      title\n      copy\n      splitter\n    }\n  }\n"])));
var AnnualQuote = (0,graphql_tag_lib/* gql */.Ps)(_templateObject34 || (_templateObject34 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment AnnualQuote on PageBodyAnnual_quote {\n    type\n    primary {\n      align\n    }\n    fields {\n      image\n      copy\n      link {\n        ...LinkFragment\n      }\n      link_text\n    }\n  }\n"])));
var SliceBecomeCustomer = (0,graphql_tag_lib/* gql */.Ps)(_templateObject35 || (_templateObject35 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceBecomeCustomer on PageBodyBecome_a_customer {\n    type\n    primary {\n      title\n      copy\n      background\n      link_text\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var TextWithNumbers = (0,graphql_tag_lib/* gql */.Ps)(_templateObject36 || (_templateObject36 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment TextWithNumbers on PageBodyText_with_numbers {\n    type\n    primary {\n      copy\n      label\n      description\n      color\n    }\n    fields {\n      number\n      text\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var Boxes = (0,graphql_tag_lib/* gql */.Ps)(_templateObject37 || (_templateObject37 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment Boxes on PageBodyBoxes {\n    type\n    fields {\n      image\n      copy\n      table\n      align_content\n    }\n  }\n"])));
var TableWithLargeText = (0,graphql_tag_lib/* gql */.Ps)(_templateObject38 || (_templateObject38 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment TableWithLargeText on PageBodyTable_with_large_text {\n    type\n    primary {\n      text\n    }\n    fields {\n      text_1\n      text_2\n      text_3\n      text_4\n      text_5\n      isheader\n      isfooter\n      bold\n    }\n  }\n"])));
var SliceServiceLocations = (0,graphql_tag_lib/* gql */.Ps)(_templateObject39 || (_templateObject39 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceServiceLocations on PageBodyService_locations {\n    type\n  }\n"])));
var sliceFragments_SlicePoints = (0,graphql_tag_lib/* gql */.Ps)(_templateObject40 || (_templateObject40 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SlicePoints on PageBodyPoints {\n    type\n    fields {\n      title\n      text\n    }\n    primary {\n      title\n      text\n      featured_point_title\n      featured_point_text\n      isgray\n    }\n  }\n"])));
var sliceFragments_SliceFaq = (0,graphql_tag_lib/* gql */.Ps)(_templateObject41 || (_templateObject41 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceFaq on PageBodyFaq {\n    type\n    primary {\n      heading\n      single_display\n    }\n    fields {\n      item {\n        ... on Faq_item {\n          question\n          answer\n        }\n      }\n      category {\n        ... on Faq_category {\n          title\n        }\n      }\n    }\n  }\n"])));
var SliceContentNav = (0,graphql_tag_lib/* gql */.Ps)(_templateObject42 || (_templateObject42 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceContentNav on PageBodyContent_nav {\n    type\n    primary {\n      heading\n    }\n    fields {\n      subheading\n      copy\n    }\n  }\n"])));
var sliceFragments_SliceInterestCallout = (0,graphql_tag_lib/* gql */.Ps)(_templateObject43 || (_templateObject43 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceInterestCallout on PageBodyInterest_callout {\n    type\n    label\n    fields {\n      title\n      copy\n      sub_title\n      number\n      number_color\n      subtitle_position\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var sliceFragments_SliceStaffWithContact = (0,graphql_tag_lib/* gql */.Ps)(_templateObject44 || (_templateObject44 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceStaffWithContact on PageBodyStaff_with_contact {\n    type\n    primary {\n      title\n      three_per_line\n    }\n    fields {\n      employee {\n        ... on Employee {\n          image\n          name\n          title\n          email\n          phone\n          location\n        }\n      }\n    }\n  }\n"])));
var sliceFragments_SliceStaffWithBio = (0,graphql_tag_lib/* gql */.Ps)(_templateObject45 || (_templateObject45 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceStaffWithBio on PageBodyStaff_with_bio {\n    type\n    primary {\n      title\n    }\n    fields {\n      employee {\n        ... on Employee {\n          image\n          name\n          title\n          bio\n        }\n      }\n    }\n  }\n"])));
var SliceDetailCards = (0,graphql_tag_lib/* gql */.Ps)(_templateObject46 || (_templateObject46 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceDetailCards on PageBodyDetail_cards {\n    type\n    primary {\n      title\n      three_per_line\n    }\n    fields {\n      image\n      detail_title\n      details\n      show_image\n    }\n  }\n"])));
var sliceFragments_SliceNewsCards = (0,graphql_tag_lib/* gql */.Ps)(_templateObject47 || (_templateObject47 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceNewsCards on PageBodyNews_cards {\n    type\n    primary {\n      heading\n      heading_link {\n        ...LinkFragment\n      }\n      featured\n      articles\n    }\n    fields {\n      article {\n        ...LinkFragment\n      }\n      category {\n        ... on Article_category {\n          _meta {\n            id\n            uid\n          }\n          title\n        }\n      }\n      article_abstract\n    }\n  }\n"])));
var sliceFragments_SliceMoreInfo = (0,graphql_tag_lib/* gql */.Ps)(_templateObject48 || (_templateObject48 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceMoreInfo on PageBodyMore_info {\n    type\n    primary {\n      title\n      expandable\n    }\n    fields {\n      image\n      title\n      copy\n      expandable\n    }\n  }\n"])));
var SliceCardInfo = (0,graphql_tag_lib/* gql */.Ps)(_templateObject49 || (_templateObject49 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceCardInfo on PageBodyCard_info {\n    type\n    primary {\n      title\n      copy\n      image\n      insurance\n      terms {\n        ...LinkFragment\n      }\n    }\n    fields {\n      first_text\n      second_text\n    }\n  }\n"])));
var SliceCustomModule = (0,graphql_tag_lib/* gql */.Ps)(_templateObject50 || (_templateObject50 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceCustomModule on PageBodyCustom_module {\n    type\n    primary {\n      module\n      background\n    }\n  }\n"])));
var SliceHousingLoanCalculator = (0,graphql_tag_lib/* gql */.Ps)(_templateObject51 || (_templateObject51 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceHousingLoanCalculator on PageBodyHousing_loan_calculator {\n    type\n    primary {\n      refinancing\n    }\n  }\n"])));
var SliceIframe = (0,graphql_tag_lib/* gql */.Ps)(_templateObject52 || (_templateObject52 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceIframe on PageBodyIframe {\n    type\n    primary {\n      copy\n    }\n  }\n"])));
var SliceMailingList = (0,graphql_tag_lib/* gql */.Ps)(_templateObject53 || (_templateObject53 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceMailingList on PageBodyMailing_list {\n    type\n    primary {\n      mailing_list_categories\n    }\n    fields {\n      mailing_list_category\n      mailing_list_title\n      mailing_list_text\n      mailing_list_order\n    }\n  }\n"])));
var sliceFragments_SliceTable = (0,graphql_tag_lib/* gql */.Ps)(_templateObject54 || (_templateObject54 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceTable on PageBodyTable {\n    type\n    primary {\n      bg: background\n      layout\n      zebra_color\n      text\n      table_title\n      table\n    }\n  }\n"])));
var sliceFragments_SliceQuarters = (0,graphql_tag_lib/* gql */.Ps)(_templateObject55 || (_templateObject55 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceQuarters on PageBodyQuarters {\n    type\n    fields {\n      copy\n      link {\n        ...LinkFragment\n      }\n    }\n  }\n"])));
var sliceFragments_SliceTextWithImages = (0,graphql_tag_lib/* gql */.Ps)(_templateObject56 || (_templateObject56 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceTextWithImages on PageBodyText_with_images {\n    type\n    primary {\n      title\n      copy\n      align\n      link_text\n      aspect_ratio\n      link {\n        ...LinkFragment\n      }\n      link_2_text\n      link_2 {\n        ...LinkFragment\n      }\n    }\n    fields {\n      image\n      video\n      embed\n      infogramid\n    }\n  }\n"])));
var sliceFragments_SliceAccordion = (0,graphql_tag_lib/* gql */.Ps)(_templateObject57 || (_templateObject57 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceAccordion on PageBodyAccordion {\n    type\n    primary {\n      is_open\n      single_display\n    }\n    fields {\n      page {\n        ... on Page {\n          _meta {\n            id\n            uid\n            tags\n            lang\n          }\n          page_title\n          body {\n            ...SliceQuarters\n            ...SliceTextWithImages\n            ...SliceTable\n          }\n        }\n      }\n    }\n  }\n"])));
var SliceMarkets = (0,graphql_tag_lib/* gql */.Ps)(_templateObject58 || (_templateObject58 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceMarkets on PageBodyMarkets {\n    type\n    primary {\n      instrument\n      order\n      disclaimer\n    }\n  }\n"])));
var SliceEventRegistration = (0,graphql_tag_lib/* gql */.Ps)(_templateObject59 || (_templateObject59 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceEventRegistration on PageBodyEvent_sign_up {\n    type\n    label\n    primary {\n      event_id\n      image\n      description\n      use_phonenumber\n      use_kennitala\n      use_company_name\n      use_company_kennitala\n      max_number_registering\n      max_number_registering_label\n      title\n    }\n    fields {\n      field_name\n      field_type\n      field_position\n      field_size\n    }\n  }\n"])));
var SliceGdprRequest = (0,graphql_tag_lib/* gql */.Ps)(_templateObject60 || (_templateObject60 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceGdprRequest on PageBodyGdprrequest {\n    type\n    primary {\n      type\n      text\n      header\n      login_title\n      login_description\n      login_image\n    }\n  }\n"])));
var sliceFragments_SliceShortcuts = (0,graphql_tag_lib/* gql */.Ps)(_templateObject61 || (_templateObject61 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceShortcuts on PageBodyShortcuts {\n    type\n    fields {\n      icon\n      link {\n        ...LinkFragment\n      }\n      link_text\n    }\n  }\n"])));
var SliceFeaturedPodcasts = (0,graphql_tag_lib/* gql */.Ps)(_templateObject62 || (_templateObject62 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceFeaturedPodcasts on PageBodyFeatured_podcasts {\n    type\n    primary {\n      title\n      description\n      button_text\n      button_link {\n        ...LinkFragment\n      }\n    }\n    fields {\n      podcast_link {\n        ...LinkFragment\n      }\n      podcast_duration\n    }\n  }\n"])));
var SliceOrderGiftCard = (0,graphql_tag_lib/* gql */.Ps)(_templateObject63 || (_templateObject63 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceOrderGiftCard on PageBodyOrder_gift_card {\n    type\n    primary {\n      type\n    }\n  }\n"])));
var SliceBookAppointment = (0,graphql_tag_lib/* gql */.Ps)(_templateObject64 || (_templateObject64 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceBookAppointment on PageBodyBook_appointment {\n    type\n    primary {\n      type\n      default_corporate_service\n      default_personal_service\n      image\n      copy\n      title\n    }\n  }\n"])));
var SliceTermsDialog = (0,graphql_tag_lib/* gql */.Ps)(_templateObject65 || (_templateObject65 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceTermsDialog on PageBodyTerms_dialog {\n    type\n    primary {\n      title\n      content\n      open_on_load\n    }\n  }\n"])));
var SliceKauphollNews = (0,graphql_tag_lib/* gql */.Ps)(_templateObject66 || (_templateObject66 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceKauphollNews on PageBodyKaupholl_news {\n    type\n    primary {\n      title\n      description\n      count\n    }\n  }\n"])));
var SliceImageLink = (0,graphql_tag_lib/* gql */.Ps)(_templateObject67 || (_templateObject67 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceImageLink on PageBodyImage_link {\n    type\n    fields {\n      title\n      link {\n        ...LinkFragment\n      }\n      color\n      image\n    }\n  }\n"])));
var sliceFragments_SliceInfogram = (0,graphql_tag_lib/* gql */.Ps)(_templateObject68 || (_templateObject68 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceInfogram on PageBodyInfogram {\n    type\n    primary {\n      infogramid\n    }\n  }\n"])));
var SliceScrollToModuleOnLoad = (0,graphql_tag_lib/* gql */.Ps)(_templateObject69 || (_templateObject69 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment SliceScrollToModuleOnLoad on PageBodyScrolltomoduleonload {\n    type\n    fields {\n      module_name\n    }\n  }\n"])));
var allFragments = [FrontPageHero, SubPageHero, CompactHero, SliceText, SliceTextWithPoints, SliceIntroText, SliceImages, SliceEmbed, SliceTableWithImages, SliceRelatedContent, SliceProductCards, SliceArticleCards, SliceOtherCards, SliceTextCards, SliceTableWithImages, HighlightNumbers, SlicePageVideo, SliceArticleHero, SliceFeaturedArticles, SliceTextWithImage, SliceTextWithVideo, SliceTextWithPullOut, SliceTextWithWithSideText, SliceTextWithRelated, SliceTextWithLinks, SliceEmphasisText, SliceQuote, SliceVideo, AnnualHero, SliceAnnualModule, Tiles, AnnualIntro, AnnualQuote, TextWithNumbers, Boxes, TableWithLargeText, SliceBecomeCustomer, SliceJotForm, SliceServiceLocations, sliceFragments_SlicePoints, sliceFragments_SliceFaq, SliceContentNav, sliceFragments_SliceInterestCallout, sliceFragments_SliceStaffWithContact, sliceFragments_SliceStaffWithBio, SliceDetailCards, sliceFragments_SliceNewsCards, sliceFragments_SliceMoreInfo, SliceCardInfo, SliceCustomModule, SliceDownloadLinks, SliceIframe, SliceMailingList, SliceMarkets, SliceEventRegistration, sliceFragments_SliceQuarters, sliceFragments_SliceTable, sliceFragments_SliceAccordion, sliceFragments_SliceTextWithImages, SliceGdprRequest, sliceFragments_SliceShortcuts, SliceFeaturedPodcasts, SliceOrderGiftCard, SliceBookAppointment, SliceTermsDialog, SliceKauphollNews, SliceImageLink, sliceFragments_SliceInfogram, SliceScrollToModuleOnLoad];
;// CONCATENATED MODULE: ./src/graphql/prismic/fragments/sliceFragments.ts

var sliceFragments_allFragments = [AnnualIntro, AnnualQuote, AnnualHero, Boxes, CompactHero, FrontPageHero, HighlightNumbers, SliceAnnualModule, SliceArticleCards, SliceArticleHero, SliceEmbed, SliceEmphasisText, sliceFragments_SliceFaq, SliceFeaturedArticles, SliceImages, sliceFragments_SliceInterestCallout, SliceIntroText, SliceOtherCards, SlicePageVideo, SliceProductCards, SliceQuote, SliceRelatedContent, SliceTableWithImages, SliceTextCards, SliceTextWithImage, SliceTextWithLinks, SliceTextWithPoints, SliceTextWithPullOut, SliceTextWithRelated, SliceTextWithVideo, SliceTextWithWithSideText, SliceVideo, SubPageHero, TableWithLargeText, TextWithNumbers, Tiles, SliceText // don't order this alphabetically, needs to be in the same chunk as arsskyrsla fragment
];
;// CONCATENATED MODULE: ./src/graphql/prismic/pageQuery.ts



var pageQuery_templateObject, pageQuery_templateObject2;






function getChunks(fragments, chunks) {
  var res = [];
  /* Puts all together, then splits it evenly amoung sub arrays (remainders are included) */

  for (var i = chunks; i > 0; i--) {
    res.push(fragments.splice(0, Math.ceil(fragments.length / i)));
  }

  return res;
}

var chunks = getChunks([].concat((0,toConsumableArray/* default */.Z)(sliceFragments_allFragments), (0,toConsumableArray/* default */.Z)(arsskyrslaFragments)), 3);
var pageQueries = chunks.map(function (fragments) {
  var fragmentNames = fragments.map(function (x) {
    var _x$definitions$, _x$definitions$$name;

    return x === null || x === void 0 ? void 0 : (_x$definitions$ = x.definitions[0]) === null || _x$definitions$ === void 0 ? void 0 : (_x$definitions$$name = _x$definitions$.name) === null || _x$definitions$$name === void 0 ? void 0 : _x$definitions$$name.value;
  });
  return (0,lib/* gql */.Ps)(pageQuery_templateObject || (pageQuery_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n    ", "\n    fragment ParentPage on Page {\n      _meta {\n        id\n        uid\n        tags\n        lang\n      }\n      page_title\n      sub_navigation {\n        link_text\n        link {\n          ...LinkFragment\n        }\n      }\n    }\n    query page($uid: String!, $lang: String!) {\n      page(uid: $uid, lang: $lang) {\n        page_title\n        abstract\n        abstract_image\n        seo_title\n\t      seo_description\n\t      seo_image\n        slug\n        sub_navigation {\n          link_text\n          link {\n            ...LinkFragment\n          }\n        }\n        hide_sub_nav\n        cta_button {\n          ...LinkFragment\n        }\n        cta_button_text\n        cta_mobile_button_text\n        parent {\n          ...ParentPage\n          ... on Page {\n            parent {\n              ...ParentPage\n            }\n          }\n        }\n        _meta {\n          id\n          uid\n          tags\n          lang\n          alternateLanguages {\n            id\n            lang\n          }\n        }\n        become_a_custmer_enabled\n        body {\n          __typename\n          ", "\n        }\n      }\n    }\n  "])), LinkFragment, fragments.reduce(function (acc, fragment) {
    return (0,lib/* gql */.Ps)(pageQuery_templateObject2 || (pageQuery_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n          ", "\n          ", "\n        "])), acc, fragment);
  }, ''), fragmentNames.map(function (name) {
    return "...".concat(name, "\n");
  }));
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../packages/prismic/src/development.ts
var development = __webpack_require__(26655);
// EXTERNAL MODULE: ../../packages/prismic/src/api.ts + 3 modules
var api = __webpack_require__(14110);
;// CONCATENATED MODULE: ./src/graphql/prismic/navigationQuery.ts


var navigationQuery_templateObject;



var navigationQuery = (0,lib/* gql */.Ps)(navigationQuery_templateObject || (navigationQuery_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  query nav($lang: String, $ids: [String!]) {\n    allNavigations(lang: $lang, id_in: $ids) {\n      edges {\n        node {\n          _meta {\n            id\n            uid\n            type\n            lang\n          }\n          title\n          link {\n            ...LinkFragment\n          }\n          visible\n          body {\n            ... on NavigationBody2nd_level {\n              primary {\n                link_text\n                nav_link {\n                  ...LinkFragment\n                }\n              }\n              fields {\n                third_level_link {\n                  ...LinkFragment\n                }\n                third_level_link_text\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])), LinkFragment);
;// CONCATENATED MODULE: ./src/graphql/prismic/websiteQuery.ts


var websiteQuery_templateObject;



var websiteQuery = (0,lib/* gql */.Ps)(websiteQuery_templateObject || (websiteQuery_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", "\n  query website($lang: String = \"is\") {\n    allWebsites(lang: $lang) {\n      edges {\n        node {\n          _meta {\n            id\n            uid\n            tags\n            lang\n            alternateLanguages {\n              id\n              uid\n              lang\n            }\n            firstPublicationDate\n            lastPublicationDate\n          }\n          title\n          seo_image\n          seo_description\n          navigation {\n            navigation_title\n            navigation_item {\n              ...LinkFragment\n            }\n          }\n          quicklinks {\n            quicklink_title\n            quicklink_icon\n            quicklink_link {\n              ...LinkFragment\n            }\n          }\n          opening_hours\n          bottom_links {\n            bottomlink_title\n            bottomlink_link {\n              ...LinkFragment\n            }\n          }\n          cards {\n            card_heading\n            card_image\n            card_copy\n            card_link {\n              ...LinkFragment\n            }\n          }\n          text\n          shortcuts {\n            s_icon\n            s_link {\n              ...LinkFragment\n            }\n            s_text\n            s_param\n          }\n          social_media {\n            icon\n            link_text\n            link {\n              ...LinkFragment\n            }\n          }\n          bac_copy\n          bac_title\n          bac_background\n          bac_link_text\n          bac_link {\n            ...LinkFragment\n          }\n          bac_images {\n            image\n          }\n          body {\n            ... on WebsiteBodyGroup {\n              primary {\n                group_title\n              }\n              fields {\n                link {\n                  ...LinkFragment\n                }\n                link_text\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])), LinkFragment);
// EXTERNAL MODULE: ./src/lib/prismicIntrospect.json
var prismicIntrospect = __webpack_require__(14083);
;// CONCATENATED MODULE: ./src/lib/getStaticProps.ts





function getStaticProps_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getStaticProps_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getStaticProps_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getStaticProps_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function extractNavigationItemIds(website) {
  var _website$navigation;

  return website === null || website === void 0 ? void 0 : (_website$navigation = website.navigation) === null || _website$navigation === void 0 ? void 0 : _website$navigation.map(function (item) {
    var _item$navigation_item, _item$navigation_item2;

    return item === null || item === void 0 ? void 0 : (_item$navigation_item = item.navigation_item) === null || _item$navigation_item === void 0 ? void 0 : (_item$navigation_item2 = _item$navigation_item._meta) === null || _item$navigation_item2 === void 0 ? void 0 : _item$navigation_item2.id;
  }).filter(function (n) {
    return !!n;
  });
}

function mergeWebsiteNavigations(website, navigations) {
  return getStaticProps_objectSpread(getStaticProps_objectSpread({}, website), {}, {
    navigation: website.navigation.map(function (item) {
      return getStaticProps_objectSpread(getStaticProps_objectSpread({}, item), {}, {
        navigation_item: getStaticProps_objectSpread(getStaticProps_objectSpread({}, item.navigation_item), navigations.find(function (n) {
          var _n$_meta, _item$navigation_item3, _item$navigation_item4;

          return (n === null || n === void 0 ? void 0 : (_n$_meta = n._meta) === null || _n$_meta === void 0 ? void 0 : _n$_meta.id) === (item === null || item === void 0 ? void 0 : (_item$navigation_item3 = item.navigation_item) === null || _item$navigation_item3 === void 0 ? void 0 : (_item$navigation_item4 = _item$navigation_item3._meta) === null || _item$navigation_item4 === void 0 ? void 0 : _item$navigation_item4.id);
        }))
      });
    })
  });
} // this query is split to bypass the maximum 9 level query limit
// @reference https://prismic.io/docs/graphql/query-the-api/fetch-linked-document-fields


function getWebsiteData(_x) {
  return _getWebsiteData.apply(this, arguments);
}

function _getWebsiteData() {
  _getWebsiteData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var _websiteRes$data$allW, _websiteRes$data, _websiteRes$data$allW2, _navigationRes$data$a, _navigationRes$data, _navigationRes$data$a2;

    var lang,
        websiteData,
        websiteRes,
        _ref2,
        _ref3,
        websiteEdge,
        website,
        ids,
        navigationRes,
        navigations,
        response,
        _args2 = arguments;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            lang = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'is';

            if (!(config/* Config.REDIS_URL */.D.REDIS_URL !== '')) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return development/* rclient.get */.bU.get("WEBSITE_DATA_".concat(lang));

          case 4:
            websiteData = _context2.sent;

            if (!websiteData) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", JSON.parse(websiteData));

          case 7:
            _context2.next = 9;
            return client.query({
              query: websiteQuery,
              variables: {
                lang: lang
              }
            });

          case 9:
            websiteRes = _context2.sent;
            _ref2 = (_websiteRes$data$allW = (_websiteRes$data = websiteRes.data) === null || _websiteRes$data === void 0 ? void 0 : (_websiteRes$data$allW2 = _websiteRes$data.allWebsites) === null || _websiteRes$data$allW2 === void 0 ? void 0 : _websiteRes$data$allW2.edges) !== null && _websiteRes$data$allW !== void 0 ? _websiteRes$data$allW : [], _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1), websiteEdge = _ref3[0];
            website = websiteEdge === null || websiteEdge === void 0 ? void 0 : websiteEdge.node; // extract wanted navigation IDs

            ids = extractNavigationItemIds(website); // fetch navigations

            _context2.next = 15;
            return client.query({
              query: navigationQuery,
              variables: {
                ids: ids,
                lang: lang
              }
            });

          case 15:
            navigationRes = _context2.sent;
            navigations = ((_navigationRes$data$a = (_navigationRes$data = navigationRes.data) === null || _navigationRes$data === void 0 ? void 0 : (_navigationRes$data$a2 = _navigationRes$data.allNavigations) === null || _navigationRes$data$a2 === void 0 ? void 0 : _navigationRes$data$a2.edges) !== null && _navigationRes$data$a !== void 0 ? _navigationRes$data$a : []).map(function (n) {
              return n.node;
            }); // merge navigations into website navigation items

            response = mergeWebsiteNavigations(website, navigations); // set redis cache

            if (config/* Config.REDIS_URL */.D.REDIS_URL !== '') {
              development/* rclient.set */.bU.set("WEBSITE_DATA_".concat(lang), JSON.stringify(response), 60 * 2);
            }

            return _context2.abrupt("return", response);

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getWebsiteData.apply(this, arguments);
}

function getStaticPropsData(_x2, _x3) {
  return _getStaticPropsData.apply(this, arguments);
}

function _getStaticPropsData() {
  _getStaticPropsData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(props, overwriteLang) {
    var _ref5, _overwriteLang$toLoca, _props$params;

    var _ref4, _ref4$preview, preview, _ref4$previewData, previewData, _concat, _concat2, lang, client, pages, website, extractProps, withStaticData;

    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            withStaticData = function _withStaticData() {
              var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var revalidate = arguments.length > 1 ? arguments[1] : undefined;
              return {
                props: getStaticProps_objectSpread(getStaticProps_objectSpread({}, data), extractProps()),
                revalidate: revalidate !== null && revalidate !== void 0 ? revalidate : config/* Config.REVALIDATION_TIMEOUT */.D.REVALIDATION_TIMEOUT
              };
            };

            extractProps = function _extractProps() {
              return {
                lang: lang,
                pages: pages,
                website: website,
                preview: preview,
                previewData: previewData,
                initialApolloState: client.cache.extract()
              };
            };

            _ref4 = props || {}, _ref4$preview = _ref4.preview, preview = _ref4$preview === void 0 ? null : _ref4$preview, _ref4$previewData = _ref4.previewData, previewData = _ref4$previewData === void 0 ? null : _ref4$previewData;
            _concat = [].concat((_ref5 = (_overwriteLang$toLoca = overwriteLang === null || overwriteLang === void 0 ? void 0 : overwriteLang.toLocaleLowerCase()) !== null && _overwriteLang$toLoca !== void 0 ? _overwriteLang$toLoca : props === null || props === void 0 ? void 0 : (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.lang) !== null && _ref5 !== void 0 ? _ref5 : 'is'), _concat2 = (0,slicedToArray/* default */.Z)(_concat, 1), lang = _concat2[0];
            _context3.t0 = api/* getApolloClient */.WQ;
            _context3.t1 = prismicIntrospect;
            _context3.next = 8;
            return (0,development/* getInitialState */.aY)();

          case 8:
            _context3.t2 = _context3.sent;
            _context3.t3 = preview ? previewData === null || previewData === void 0 ? void 0 : previewData.ref : null;
            _context3.t4 = {
              introspectionQueryResultData: _context3.t1,
              initialState: _context3.t2,
              prismicRef: _context3.t3
            };
            client = (0, _context3.t0)(_context3.t4);
            _context3.next = 14;
            return (0,linkResolver/* allPages */.vI)(lang, previewData === null || previewData === void 0 ? void 0 : previewData.ref);

          case 14:
            pages = _context3.sent;
            _context3.next = 17;
            return getWebsiteData(client, lang);

          case 17:
            website = _context3.sent;
            _context3.next = 20;
            return (0,development/* setInitialState */.KY)(client.cache);

          case 20:
            // no need to push cache for pages and website
            client.cache.reset();
            return _context3.abrupt("return", {
              client: client,
              pages: pages,
              website: website,
              withStaticData: withStaticData,
              extractProps: extractProps
            });

          case 22:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getStaticPropsData.apply(this, arguments);
}

function getStaticPropsDefaults() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? 'is' : _ref$lang;

  return /*#__PURE__*/function () {
    var _getStaticProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(props) {
      var _yield$getStaticProps, extractProps;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              props.params = props.params || {};
              props.params.lang = lang;
              _context.next = 4;
              return getStaticPropsData(props);

            case 4:
              _yield$getStaticProps = _context.sent;
              extractProps = _yield$getStaticProps.extractProps;
              return _context.abrupt("return", {
                props: extractProps(),
                revalidate: Config.REVALIDATION_TIMEOUT
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getStaticProps(_x4) {
      return _getStaticProps.apply(this, arguments);
    }

    return getStaticProps;
  }();
}
// EXTERNAL MODULE: ./src/pages/_error.tsx
var _error = __webpack_require__(26081);
;// CONCATENATED MODULE: ./src/pages/[...page].tsx





function _page_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _page_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _page_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _page_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _page_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ekm0f3q1"
} : 0)( true ? {
  name: "1lmwj45",
  styles: "&>div>section{position:relative;z-index:2;}"
} : 0);

var StyledSubNavContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SubnavContainer,  true ? {
  target: "ekm0f3q0"
} : 0)("ul{@media (max-width: 1400px){margin-left:auto;margin-right:58px;}}li{", (0,mixins/* responseFont */.cG)(12, 16), "@media (max-width: 1200px){padding-left:10px;padding-right:10px;", (0,mixins/* responseFont */.cG)(12, 14), ";}@media (max-width: 1200px){padding-left:5px;padding-right:5px;}}h2{@media (max-width: 1400px){margin-left:80px;width:166px;}@media (max-width: 1300px){}@media (max-width: 1200px){width:auto;}}" + ( true ? "" : 0));

var __N_SSG = true;
function usePageData(page, lang) {
  var res = (0,src/* useMergedQueries */.vN)(pageQueries, {
    variables: {
      uid: page === null || page === void 0 ? void 0 : page.uid,
      lang: lang
    }
  });
  return res.data;
}
function getPageData(_x) {
  return _getPageData.apply(this, arguments);
}

function _getPageData() {
  _getPageData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref) {
    var _ref$url, url, _ref$lang, lang, pages, client, page, _iterator2, _step2, pageQuery;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref$url = _ref.url, url = _ref$url === void 0 ? '' : _ref$url, _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? 'is' : _ref$lang, pages = _ref.pages, client = _ref.client;
            page = pages.find(function (p) {
              return p.url === url;
            }) || null;

            if (!page) {
              _context2.next = 20;
              break;
            }

            _iterator2 = _createForOfIteratorHelper(pageQueries);
            _context2.prev = 4;

            _iterator2.s();

          case 6:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 12;
              break;
            }

            pageQuery = _step2.value;
            _context2.next = 10;
            return client.query({
              query: pageQuery,
              variables: {
                lang: lang,
                uid: page.uid
              }
            });

          case 10:
            _context2.next = 6;
            break;

          case 12:
            _context2.next = 17;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](4);

            _iterator2.e(_context2.t0);

          case 17:
            _context2.prev = 17;

            _iterator2.f();

            return _context2.finish(17);

          case 20:
            return _context2.abrupt("return", page);

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 14, 17, 20]]);
  }));
  return _getPageData.apply(this, arguments);
}

function getStaticPageProps() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _opts$lang = opts.lang,
      lang = _opts$lang === void 0 ? 'is' : _opts$lang,
      _opts$prefix = opts.prefix,
      prefix = _opts$prefix === void 0 ? '' : _opts$prefix;
  return /*#__PURE__*/function () {
    var _getStaticProps = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(props) {
      var _opts$page;

      var _yield$getStaticProps, extractProps, pages, client, url, page, _iterator, _step, pageQuery;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              props.params = props.params || {};
              props.params.page = (_opts$page = opts.page) !== null && _opts$page !== void 0 ? _opts$page : props.params.page;
              props.params.lang = lang;
              _context.next = 5;
              return getStaticPropsData(props);

            case 5:
              _yield$getStaticProps = _context.sent;
              extractProps = _yield$getStaticProps.extractProps;
              pages = _yield$getStaticProps.pages;
              client = _yield$getStaticProps.client;
              url = "".concat(prefix, "/").concat([].concat(props.params.page).join('/'));
              page = pages.find(function (p) {
                return p.url === url;
              }) || false;

              if (!page) {
                page = pages.find(function (p) {
                  return p.url === '/404-skilabod';
                }) || false;
              }

              if (!page) {
                _context.next = 30;
                break;
              }

              _iterator = _createForOfIteratorHelper(pageQueries);
              _context.prev = 14;

              _iterator.s();

            case 16:
              if ((_step = _iterator.n()).done) {
                _context.next = 22;
                break;
              }

              pageQuery = _step.value;
              _context.next = 20;
              return client.query({
                query: pageQuery,
                variables: {
                  lang: lang,
                  uid: page.uid
                }
              });

            case 20:
              _context.next = 16;
              break;

            case 22:
              _context.next = 27;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](14);

              _iterator.e(_context.t0);

            case 27:
              _context.prev = 27;

              _iterator.f();

              return _context.finish(27);

            case 30:
              return _context.abrupt("return", {
                props: _page_objectSpread(_page_objectSpread({
                  page: page
                }, extractProps()), {}, {
                  lang: lang
                }),
                notFound: !page,
                revalidate: config/* Config.REVALIDATION_TIMEOUT */.D.REVALIDATION_TIMEOUT
              });

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[14, 24, 27, 30]]);
    }));

    function getStaticProps(_x2) {
      return _getStaticProps.apply(this, arguments);
    }

    return getStaticProps;
  }();
}

function getRootPage(page) {
  var _rootPage, _rootPage2;

  var n = page;
  var rootPage = page;

  while (n) {
    var _n, _n2;

    var parentItems = (((_n = n) === null || _n === void 0 ? void 0 : _n.sub_navigation) || []).filter(function (x) {
      return !!(x !== null && x !== void 0 && x.link);
    });
    rootPage = n;
    n = parentItems.length ? null : (_n2 = n) === null || _n2 === void 0 ? void 0 : _n2.parent;
  }

  if (!((_rootPage = rootPage) !== null && _rootPage !== void 0 && _rootPage.parentPage) && !(((_rootPage2 = rootPage) === null || _rootPage2 === void 0 ? void 0 : _rootPage2.sub_navigation) || []).filter(function (x) {
    return !!(x !== null && x !== void 0 && x.link);
  }).length) {
    rootPage = page;
  }

  return rootPage;
}

function Page(_ref2) {
  var _data$page, _data$page2, _data$page2$_meta, _data$page3, _data$page3$_meta, _Config$CANONICAL_URL, _data$page4, _data$page5, _data$page6, _data$page7;

  var page = _ref2.page,
      lang = _ref2.lang,
      preview = _ref2.preview,
      website = _ref2.website,
      pages = _ref2.pages;
  var router = (0,next_router.useRouter)();
  var res = (0,src/* useMergedQueries */.vN)(pageQueries, {
    variables: {
      uid: page === null || page === void 0 ? void 0 : page.uid,
      lang: lang
    }
  });
  var data = res.data;

  if (!preview && !page || preview && !router.isFallback && !page) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_error["default"], {
      statusCode: 404
    });
  }

  if (router.isFallback || res.loading) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: ["Loading\u2026 data: ", data ? '1' : '0', " - loading: ", res.loading ? '1' : '0']
    });
  }

  var rootPage = getRootPage(data === null || data === void 0 ? void 0 : data.page);
  var hideSubNav = (data === null || data === void 0 ? void 0 : (_data$page = data.page) === null || _data$page === void 0 ? void 0 : _data$page.hide_sub_nav) === true;
  var isFrontPage = (data === null || data === void 0 ? void 0 : (_data$page2 = data.page) === null || _data$page2 === void 0 ? void 0 : (_data$page2$_meta = _data$page2._meta) === null || _data$page2$_meta === void 0 ? void 0 : _data$page2$_meta.uid) === 'index' || false;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
    "data-wio-id": data === null || data === void 0 ? void 0 : (_data$page3 = data.page) === null || _data$page3 === void 0 ? void 0 : (_data$page3$_meta = _data$page3._meta) === null || _data$page3$_meta === void 0 ? void 0 : _data$page3$_meta.id,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MetaContainer, {
      canonicalUrlBase: (_Config$CANONICAL_URL = config/* Config.CANONICAL_URL_BASE */.D.CANONICAL_URL_BASE) !== null && _Config$CANONICAL_URL !== void 0 ? _Config$CANONICAL_URL : '',
      data: data === null || data === void 0 ? void 0 : data.page,
      breadcrumbs: (0,linkResolver/* buildBreadcrumbs */.tk)(page, pages),
      defaultTitle: website === null || website === void 0 ? void 0 : website.title,
      defaultImage: website === null || website === void 0 ? void 0 : website.seo_image,
      defaultDescription: website === null || website === void 0 ? void 0 : website.seo_description,
      isFrontPage: isFrontPage,
      siteName: "\xC1rssk\xFDrsla Landsbankans"
    }), !hideSubNav && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubNavContainer, {
      titleWidth: "274px",
      page: rootPage,
      active: data === null || data === void 0 ? void 0 : data.page,
      ctaLink: data === null || data === void 0 ? void 0 : (_data$page4 = data.page) === null || _data$page4 === void 0 ? void 0 : _data$page4.cta_button,
      ctaText: data === null || data === void 0 ? void 0 : (_data$page5 = data.page) === null || _data$page5 === void 0 ? void 0 : _data$page5.cta_button_text,
      ctaMobileText: data === null || data === void 0 ? void 0 : (_data$page6 = data.page) === null || _data$page6 === void 0 ? void 0 : _data$page6.cta_mobile_button_text
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SlicesContainer/* SlicesContainer */.p, {
      data: (_data$page7 = data.page) === null || _data$page7 === void 0 ? void 0 : _data$page7.body,
      template: "article"
    })]
  });
}

/***/ }),

/***/ 26081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20406);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _landsbankinn_shared_components_templates_intro_PageIntro__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36703);
/* harmony import */ var _landsbankinn_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62145);
/* harmony import */ var _landsbankinn_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40799);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);










var ErrorPage = function ErrorPage(_ref) {
  var statusCode = _ref.statusCode;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_landsbankinn_ui__WEBPACK_IMPORTED_MODULE_4__/* .Segment */ .X, {
    paddingBottom: 400,
    paddingTop: 200,
    style: {
      minHeight: 'calc(100vh - 500px)'
    },
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", {
        children: "404 - Landsbankinn"
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_landsbankinn_shared_components_templates_intro_PageIntro__WEBPACK_IMPORTED_MODULE_5__/* .PageIntro */ .O, {
      title: "Vefs\xED\xF0an e\xF0a skjali\xF0 fannst ekki",
      copySize: true,
      copy: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("p", {
          children: "\xC1st\xE6\xF0ur geta veri\xF0 eftirfarandi: Sl\xF3\xF0in \xE1 s\xED\xF0una er ekki til, villa var ger\xF0 vi\xF0 innsl\xE1tt e\xF0a tengillinn sem v\xEDsa\xF0i \xE1 s\xED\xF0una er rangur. S\xED\xF0an hefur veri\xF0 fjarl\xE6g\xF0 og er \xFEv\xED ekki lengur til \xE1 vef\xFEj\xF3ni. S\xED\xF0an er ekki a\xF0gengileg \xFEessa stundina"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("br", {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("p", {
          children: ["Ef \xFE\xFA finnur ekki efni\xF0 sem \xFE\xFA leitar a\xF0, \xFE\xE1 er h\xE6gt a\xF0 fylla \xFAt fyrirspurnarform, senda t\xF6lvup\xF3st \xE1 netfangi\xF0", ' ', (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
            href: "mailto:landsbankinn@landsbankinn.is",
            style: {
              textDecoration: 'underline'
            },
            children: "landsbankinn@landsbankinn.is"
          }), ' ', "me\xF0 uppl\xFDsingum um hva\xF0a s\xED\xF0u/skjal veri\xF0 var a\xF0 reyna a\xF0 sko\xF0a/finna, e\xF0a hringja \xED s\xEDma:", ' ', (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
            href: "tel:4104000",
            style: {
              fontWeight: 'bold'
            },
            children: "410 4000"
          }), "."]
        })]
      }),
      action: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_landsbankinn_ui__WEBPACK_IMPORTED_MODULE_6__/* .ArrowButton */ .b, {
        href: "mailto:landsbankinn@landsbanki.is",
        title: "landsbankinn@landsbankinn.is",
        isSmall: true
      })
    })]
  });
};

ErrorPage.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref2) {
    var res, err, statusCode;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            res = _ref2.res, err = _ref2.err;
            statusCode = res ? res.statusCode : err ? err.statusCode : 404;
            return _context.abrupt("return", {
              statusCode: statusCode
            });

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);

/***/ })

}]);